module.exports = require('./promise')



//////////////////
// WEBPACK FOOTER
// ./~/universal-promise/index.js
// module id = 765
// module chunks = 0